export const employeeVersionRoute = (employeeId, id) => `/employees/${employeeId}/versions/${id}`;
export const employeeVersionsRoute = (employeeId) => `/employees/${employeeId}/versions`;
